export function SearchAndFilterFieldSkeleton() {
  return (
    <>
      <div className="h-[52px] w-full rounded-2xl skeleton-grey"></div>
      <div className="w-3xl h-[52px] rounded-2xl skeleton-grey"></div>
    </>
  )
}
